import { siteUrl } from "@/lib/seo";

export const BRIEF_PATH = "/daily-developer-brief";

export function formatBriefDate(date: string, short = false) {
    return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        year: "numeric",
        month: short ? "short" : "long",
        day: "numeric",
    }).format(new Date(`${date}T12:00:00Z`));
}

export function briefUrl(slug?: string) {
    return siteUrl(`${BRIEF_PATH}${slug ? `/${slug}` : ""}`);
}
